import {Component, ElementRef, ViewChild, ViewEncapsulation, OnInit} from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { Title } from 'src/app/shared/title/title.interface';
import { PreviousRouteService } from './previous-route.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-authorization-denied',
    templateUrl: 'authorization-denied.component.html',
    styleUrls: ['authorization-denied.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TranslateModule]
})

  export class AuthorizationDeniedComponent implements OnInit {
    titleOptions: Title;
    constructor(private commonService: CommonService, private previousRouteService: PreviousRouteService) {
    }
    ngOnInit() {
      this.commonService.showAppHeaderChange.next(true);
      this.commonService.titleOptions = {
        'back': false,
        'pageTitle': '',
        'action': false,
        'innerHeader': false
      };
      // this.commonService.titleOptions = {
      //   'back': true,
      //   'pageTitle': 'Go to previous page',
      //   'action': false,
      //   'innerHeader': true,
      //   'buttonText': '',
      //   'backFunction': this.back,
      // };
      // this.commonService.component = this;
    }

    // back(e: any, _this: any) {
    //   _this.previousRouteService.navigationBack();
    // }

  }
